// extracted by mini-css-extract-plugin
export default {"button":"CreateFooter_button__Sd42L","errorButton":"CreateFooter_errorButton__qmmHs"};